import { frontendURL } from '../../../helper/URLHelper';
import DashboardAppShow from './pages/DashboardAppShow.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/dashboard-apps/:dashboardAppId'),
    name: 'dashboard_apps_show',
    component: DashboardAppShow,
    meta: commonMeta,
  },
];
